import { useFormContext } from 'react-hook-form';
import { FormField } from './BaseFormComponents';
import { BaseFormFieldWrapper } from './BaseFormFieldWrapper';
import {
  ButtonGroupInput,
  ButtonGroupInputProps,
} from './base-components/ButtonGroupInput';
import { FormComponentBaseProps } from './types/form-base-props';

export type FormButtonGroupProps = FormComponentBaseProps &
  ButtonGroupInputProps;

export const FormButtonGroup = ({
  description,
  descriptionProps,
  label,
  labelProps,
  hideError,
  defaultValue,
  name,
  disabled,
  ...props
}: FormButtonGroupProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      shouldUnregister={false}
      disabled={disabled}
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <BaseFormFieldWrapper
          description={description}
          descriptionProps={descriptionProps}
          label={label}
          labelProps={labelProps}
          hideError={hideError}
        >
          <ButtonGroupInput
            {...field}
            {...props}
            onValueChange={value => field.onChange(value)}
            value={field.value}
          />
        </BaseFormFieldWrapper>
      )}
    />
  );
};
